/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProjectBoardController', ProjectBoardController);

    ProjectBoardController.$inject = ['$state', 'Principal', 'DataUtils', 'ProjectBoard', 'ProjectSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$stateParams'];

    function ProjectBoardController($state, Principal, DataUtils, ProjectBoard, ProjectSearch, ParseLinks, AlertService, paginationConstants, pagingParams, $stateParams) {

        var vm = this;

        vm.isBoard = false;
        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
            vm.allowArchive = Principal.hasAnyAuthority(['ROLE_INSTRUCTOR', 'ROLE_BOAT']) || vm.isBoard;
            updateShowTypes();
        });
        vm.allowArchive = false;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicateP;
        vm.reverse = pagingParams.ascendingP;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.searchP;
        vm.currentSearch = pagingParams.searchP;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.setType = setType;
        vm.setArchive = setArchive;
        vm.archive = pagingParams.archiveP;
        vm.type = pagingParams.typeP;
        vm.projects = [];

        loadAll();
        updateShowTypes();

        function updateShowTypes() {
            vm.showTypes = vm.isBoard || vm.type !== 'all' || vm.totalItems > vm.itemsPerPage || vm.currentSearch !== null;
            vm.showNavigation = vm.showTypes || vm.allowArchive;
        }

        function setType(type) {
            vm.page = 1;
            vm.type = type;
            vm.transition();
        }

        function setArchive(archive) {
            vm.page = 1;
            vm.archive = archive;
            vm.transition();
        }

        function loadAll () {
            if (pagingParams.searchP) {
                ProjectSearch.query({
                    query: pagingParams.searchP,
                    page: pagingParams.pageP - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ProjectBoard.query({
                    page: pagingParams.pageP - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    archive: $stateParams.archiveP,
                    type: $stateParams.typeP
                }, onSuccess, onError);
            }
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.projects = data;
                vm.page = pagingParams.pageP;
                updateShowTypes();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                pageP: vm.page,
                sortP: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                searchP: vm.currentSearch,
                archiveP: vm.archive,
                typeP: vm.type
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'fromDate';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
